import {
  DISCORD_INVITE_TICKET_LINK,
  DOCS_URL,
  FAQ_URL,
  PRIVACY_POLICY_URL,
  TOS_URL,
  YOUTUBE_URL,
} from "src/config";

import { TLinkGroup } from "./types";

export const FOOTER_LINK_GROUPS: TLinkGroup[] = [
  {
    items: [
      { name: "FAQ", href: FAQ_URL },
      { name: "Discord ticket", href: DISCORD_INVITE_TICKET_LINK },
      { name: "Docs", href: DOCS_URL },
    ],
  },
  {
    items: [
      { name: "Terms of Service", href: TOS_URL },
      { name: "Privacy Policy", href: PRIVACY_POLICY_URL },
      { name: "Tutorials", href: YOUTUBE_URL },
    ],
  },
];
